export const ItemTypes = {
	INJECT: 'inject',
	INJECT_END: 'injectEnd',
	BOX: 'box',
	VOTE: 'vote',
	RFI: 'rfi',
	INFO: 'info',
	COA: 'coa',
	TTL: 'ttl',
	NODEDOT: 'nodedot'
}
